import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import { COVERAGE_STATUS_SHORT_LABELS } from '@/utils/coverage'

/** Ordem canônica do contrato e dos chips (M10-A). */
export const COVERAGE_STATUS_ORDER: CoverageStatus[] = [
  CoverageStatus.OPEN,
  CoverageStatus.DOCTOR,
  CoverageStatus.UNIDENTIFIED
]

const VALID = new Set<string>(COVERAGE_STATUS_ORDER)

export function parseCoverageStatuses(value: unknown): CoverageStatus[] {
  const raw = Array.isArray(value) ? value : typeof value === 'string' ? value.split(',') : []
  const picked = new Set(raw.map((item) => String(item).trim()).filter((item) => VALID.has(item)))
  return COVERAGE_STATUS_ORDER.filter((status) => picked.has(status))
}

/** CSV para a query; `undefined` = sem filtro (nada marcado ou os três marcados). */
export function serializeCoverageStatuses(
  list: CoverageStatus[] | null | undefined
): string | undefined {
  const normalized = parseCoverageStatuses(list ?? [])
  if (normalized.length === 0 || normalized.length === COVERAGE_STATUS_ORDER.length)
    return undefined
  return normalized.join(',')
}

export function formatCoverageStatusFilterLabel(
  list: CoverageStatus[] | null | undefined
): string | null {
  const normalized = parseCoverageStatuses(list ?? [])
  if (normalized.length === 0 || normalized.length === COVERAGE_STATUS_ORDER.length) return null
  return `Vaga: ${normalized.map((status) => COVERAGE_STATUS_SHORT_LABELS[status].toLowerCase()).join(', ')}`
}
